import React from 'react'
import Menu from '../../components/Menu'
export default () => (
  <Menu />
)